module.exports = __webpack_public_path__ + "img/bad_pic.0c8a7769.png";